import { Collapse } from 'antd';
import Section from '../section/Section';
import { getCurrentLang } from '../../../../common/utils/lang';
import { Localised } from "../../../../common/types";
import {ReactComponent as Chevron} from "../../../../images/icons/chevron-down.svg"
import "./Faq.css";

const { Panel } = Collapse;

interface IFaq {
    header: Localised<string>;
    response: Localised<string>
}

const questions: IFaq[] = require("./faq.json");

const Faq = () => {
    const activeLang = getCurrentLang();

    const panels = questions.map((question, i) => <Panel header={question.header[activeLang]} key={`faq${i}`}>
            <p className='m-0'>{question.response[activeLang]}</p>
        </Panel>)

    return (
        <Section titlePath='home.faq.title'>
            <Collapse
                expandIconPosition="end"
                ghost
                bordered={false}
                expandIcon={({ isActive }) => <Chevron style={{ transform: `rotate(${isActive ? 180 : 0}deg)` }} />}
            >
                {panels}
            </Collapse>
        </Section>
    )
}

export default Faq;
